<template>
  <div class="app-container">
    <div class="head">
      <el-input
        style="width: 200px; margin-right: 10px"
        v-model="screen.name"
        placeholder="请输入住宅名称"
      ></el-input>
      <el-select
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        style="margin-right: 10px"
      >
      <el-option
          label="全部园区"
          value=""
        ></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-button type="danger" @click="reset()" style="margin-bottom: 5px"
        >重置</el-button
      >
      <el-button type="primary" @click="(screen.page = 1), fetchData()" style="margin-bottom: 5px"
        >搜索</el-button
      >
    </div>
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/house/add')"
        >添加</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="封面图">
        <template slot-scope="scope">
            <el-image v-for="(img,ind) in scope.row.thumb.split(',')"
            :key="ind"
            style="width: 100px; height: 100px;margin:0 5px 5px 0"
            :src="imageOss+img" 
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.thumb.split(','))">
            </el-image>
        </template>
      </el-table-column> -->
      <el-table-column label="住宅名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="业主姓名">
        <template slot-scope="scope">
          {{ scope.row.legal_name }}
        </template>
      </el-table-column>
      <el-table-column label="业主手机">
        <template slot-scope="scope">
          {{ scope.row.legal_phone }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/house/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/house/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼栋" prop="space_build_id">
          <el-select
            filterable
            v-model="ruleForm.space_build_id"
            placeholder="请选择楼栋"
            :disabled="cztype == 'see'"
            @change="spaceChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in spaceList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="space_floor_id">
          <el-select
            filterable
            v-model="ruleForm.space_floor_id"
            placeholder="请选择楼层"
            :disabled="cztype == 'see'"
            @change="floorChange"
          >
            <el-option
              :label="item.space.name + '-' + item.name"
              :value="item.id"
              v-for="(item, index) in floorList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间" prop="space_number_id">
          <el-select
            filterable
            v-model="ruleForm.space_number_id"
            placeholder="请选择房间"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.house_number"
              :value="item.id"
              v-for="(item, index) in houseList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="业主姓名" prop="legal_name">
          <el-input
            class="w4"
            v-model="ruleForm.legal_name"
            placeholder="请输入业主姓名"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="业主联系电话" prop="legal_phone">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.legal_phone"
            placeholder="请输入业主联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="业主身份证号" prop="legal_idcard">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.legal_idcard"
            placeholder="请输入业主身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="人脸照片" prop="legal_face">
          <el-upload
          :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'face' }"
            :action="ossUpload"
            :file-list="faceFileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="faceHandleRemove"
            :on-success="faceHandleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="faceBeforeAvatarUpload"
            accept=".jpg"
            :class="faceFileList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          >
          <div class="pic-tips">
            人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  openPark,
  get_space_lists,
  get_space_floor_lists,
  get_space_house_lists,
} from "@/api/index";
import {
  houseList,
  houseAdd,
  houseInfo,
  houseEdit,
  houseDel,
} from "@/api/house";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: '',
        name: "",
        legal_name: "",
        legal_phone: "",
        id: "",
      },
      total: 0,
      ruleForm: {
        park_ids: "",
        title: "",
        thumb: "",
        status: 1,
        content: "<h3>文本编辑</h3>",
        sort: "",
      },
      rules: {
        // legal_name: [
        //   { required: true, message: "请输入业主姓名", trigger: "blur" },
        // ],
        // legal_phone: [
        //   { required: true, message: "请输入业主联系电话", trigger: "blur" },
        // ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        space_build_id: [
          { required: true, message: "请选择楼栋", trigger: "change" },
        ],
        space_floor_id: [
          { required: true, message: "请选择楼层", trigger: "change" },
        ],
        space_number_id: [
          { required: true, message: "请选择房间", trigger: "change" },
        ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      fileList: [],
      spaceList: [],
      floorList: [],
      houseList: [],
      faceFileList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id=this.userInfo.park_id
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 人脸识别
    faceHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        if (this.ruleForm.legal_face) {
          this.delImg(this.ruleForm.legal_face);
        }
        this.faceFileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.legal_face = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.faceFileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 人脸识别删除
    faceHandleRemove(file) {
      this.faceFileList = [];
      this.ruleForm.legal_face = "";
    },
    // 人脸识别上传限制
    faceBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
        return false;
      }
      return isLt5M;
    },

    // 楼层选择
    floorChange(e) {
      
      this.ruleForm.space_number_id = "";
      this.getHouse();
    },
    // 获取房间列表
    getHouse() {
      get_space_house_lists({
        park_id: this.ruleForm.park_id,
        space_id: this.ruleForm.space_build_id,
        space_floor_id: this.ruleForm.space_floor_id,
      }).then((res) => {
        this.houseList = res.data.lists.data;
      });
    },
    spaceChange(e) {
      this.ruleForm.space_floor_id = "";
      this.ruleForm.space_number_id = "";
      this.getFloor();
    },
    // 获取楼层列表
    getFloor() {
      get_space_floor_lists({
        park_id: this.ruleForm.park_id,
        space_id: this.ruleForm.space_build_id,
      }).then((res) => {
        this.floorList = res.data.lists.data;
      });
    },
    parkChange(e) {
      this.ruleForm.space_build_id = "";
      this.ruleForm.space_floor_id = "";
      this.ruleForm.space_number_id = "";
      this.getSpace();
    },
    // 获取楼栋列表
    getSpace() {
      get_space_lists({ park_id: this.ruleForm.park_id }).then((res) => {
        this.spaceList = res.data.lists.data;
      });
    },

    //删除方法获取到的file是被删除的file
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.thumb = "";
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // handleAvatarSuccess(res, file,fileList) {
    //   if (res.code === 200) {
    //     // this.delImg(this.ruleForm.thumb);
    //     this.ruleForm.thumb = res.data.url;
    //   }
    //   // this.ruleForm.icon = URL.createObjectURL(file.raw)
    // },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.thumb = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      if (path) {
        delImage({ file: path }).then((ress) => {});
      }
    },
    reset() {
      this.screen = {
        park_id: '',
        page: 1,
        page_size: 15,
        name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id=this.userInfo.park_id
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.ruleForm.park_ids = this.ruleForm.park_ids.toString();
          this.$confirm("确认提交？")
            .then(() => {
              houseEdit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      houseInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        this.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          // legal_name: res.data.info.legal_name,
          // legal_phone: res.data.info.legal_phone,
          space_number_id: Number(res.data.info.space_number_id),
          space_floor_id: res.data.info.space_floor_id,
          space_build_id: res.data.info.space_build_id,
          // legal_idcard: res.data.info.legal_idcard,
          // legal_face: res.data.info.legal_face,
        };
        // this.faceFileList = [];
        // if (res.data.info.legal_face) {
        //   let list = res.data.info.legal_face.split(",");
        //   this.faceFileList = list.map((item) => {
        //     return {
        //       name: +new Date(),
        //       url: this.imageOss + item,
        //       response: {
        //         data: {
        //           url: item,
        //         },
        //       },
        //     };
        //   });
        // }
        that.getSpace();
        that.getFloor();
        that.getHouse();
      });
      this.drawer = true;
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          houseDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.ruleForm.park_ids = this.ruleForm.park_ids.toString();
          this.$confirm("确认提交？")
            .then(() => {
              houseAdd(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        // legal_name: "",
        // legal_phone: "",
        space_number_id: "",
        space_floor_id: "",
        space_build_id: "",
        // legal_phone: "",
        // legal_face: "",
      };
      this.faceFileList = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.parkChange()
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    houseDel() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          houseDel({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      const data = {
        park_id: this.screen.park_id,
        page: this.screen.page,
        page_size: this.screen.page_size,
        title: this.screen.title,
      };
      houseList(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
// select的tags过长显示...
.el-select__tags-text {
  display: inline-block;
  max-width: 140px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
